import { Component, Vue } from 'vue-property-decorator';
import authenticator from '@/store/authentication';
import appStore from '@/store/app';
import ordersStore from '@/store/orders';

@Component
export default class Home extends Vue {

    get isLoggedIn(): boolean {
        return authenticator.isLoggedIn;
    }

    get loading(): boolean {
        return appStore.isLoading;
    }

    private async login() {
        await authenticator.startSignInAsync();
    }

    private async created() {
        if (this.isLoggedIn && !ordersStore.isCartLoaded) {
            await ordersStore.fetchCartAsync({});
        }
    }
}